import qs from 'qs'
import axiosClient from '../axiosClient'

import {
  IPayloadDynamicReport,
  IPayloadExportStationRunTime,
  IPayloadFlowLog,
  IPayloadProjectLog,
  IPayloadStationRunTime,
} from './../../types/report'

const reportApi = {
  getFlowLog(payload: IPayloadFlowLog) {
    const url = '/api/report/flow-log'
    return axiosClient.get(url, {
      params: payload,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat', encode: false }),
    })
  },

  exportCsvStationRunTime(payload: IPayloadExportStationRunTime) {
    const url = '/api/report/export-station-runtime'
    return axiosClient.get(url, { params: payload, responseType: 'blob' })
  },

  exportCsvFlowLog(payload: IPayloadFlowLog) {
    const url = '/api/report/export-flow-log'
    return axiosClient.get(url, {
      params: payload,
      responseType: 'blob',
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat', encode: false }),
    })
  },
  getProjectedWater(payload: IPayloadProjectLog) {
    const url = '/api/historylog/projected-flow-log'
    return axiosClient.get(url, { params: payload })
  },

  getStationRunTime(payload: IPayloadStationRunTime) {
    const url = '/api/report/station-runtime'
    return axiosClient.get(url, { params: payload })
  },
  getProgramStart(interfaceId: number, days: number) {
    const url = `/api/report/program-start?interfaceId=${interfaceId}&days=${days}`
    return axiosClient.get(url)
  },
  getStationStart(interfaceId: number, days: number) {
    const url = `/api/report/station-start?interfaceId=${interfaceId}&days=${days}`
    return axiosClient.get(url)
  },
  getMonthyRainFall(interfaceId: number, days: number) {
    const url = `/api/report/monthly-rain-fall?interfaceId=${interfaceId}&days=${days}`
    return axiosClient.get(url)
  },
  getMonthlyET(interfaceId: number, fromTime: string, toTime: string) {
    const url = `/api/report/monthly-et?interfaceId=${interfaceId}&fromTime=${fromTime}&toTime=${toTime}`
    return axiosClient.get(url)
  },

  getAVGTemperature(interfaceId: number, fromTime: string, toTime: string) {
    const url = `/api/report/average-temperature?interfaceId=${interfaceId}&fromTime=${fromTime}&toTime=${toTime}`
    return axiosClient.get(url)
  },
  getActualWaterUsage(interfaceId: number, type: number) {
    const url = `/api/v2/historylog/actual-total-water-usage?interfaceId=${interfaceId}&type=${type}`
    return axiosClient.get(url)
  },
  getSRCReport(
    interfaceId: number,
    ts: string,
    attribute_ids: number[],
    limit: number = 1000000000,
  ) {
    const url = '/api/Report/dynamic-rainfall-log'
    return axiosClient.post(url, {
      interfaceId,
      ts,
      attributeIds: attribute_ids,
      limit,
    })
  },

  getDynamicFlowLog(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },

  exportDynamicFlowLog(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report/export'
    return axiosClient.post(url, payload, { responseType: 'blob' })
  },

  getDynamicProgramStart(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },

  getDynamicMonthlyRainfall(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },

  getDynamicStationRuntime(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },

  getDynamicStationStart(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },

  getDynamicFlowVolume(payload: IPayloadDynamicReport) {
    const url = '/api/report/dynamic-report'
    return axiosClient.post(url, payload)
  },
}

export default reportApi
